/**
 * LastTurnScrub - the LAST TURN bar over the display (plan design-gaps, Z6; the session page's scrub; ruled: it
 * replays on this screen only).
 *
 * Once a turn has passed with something in it, the bar offers it again: the play button replays its beats and walks
 * (hooks/useLastTurn), the bar fills over the replay's length and says how long it runs. Departure: a replay you
 * start, not a scrub you drag. Nothing before a turn has passed.
 *
 * @param {object} props
 * @param {object|undefined} props.lastTurn - useLastTurn's result
 */
import styles from '../../styles/Display.module.css';

export default function LastTurnScrub({ lastTurn }) {
  const last = lastTurn?.last;
  if (!last) return null;
  const playing = lastTurn.playing;
  const seconds = (last.span / 1000).toFixed(1);
  return (
    <div className={styles.scrub} data-testid="last-turn" data-playing={playing ? 'true' : undefined}>
      <button
        type="button"
        className={styles.scrubPlay}
        data-testid="last-turn-play"
        onClick={lastTurn.replay}
        disabled={!!playing}
        aria-label="Replay the last turn"
      >
        ▶ LAST TURN
      </button>
      <i className={styles.scrubBar}>
        {playing && <b key={playing} style={{ animationDuration: `${last.span}ms` }} />}
      </i>
      <span>{seconds} s</span>
    </div>
  );
}
